import * as constants from "../../constants";
import fetch from "../util/api-ajax";
import * as status from "./pageStatus";

function getWeatherMoratoriumSuccess(payload) {
  return {
    type: constants.LIST_WEATHER_MORATORIUM_SUCCESS,
    payload,
  };
}

function getTDSPCountiesSuccess(payload) {
  return {
    type: constants.LIST_TDSP_COUNTIES_SUCCESS,
    payload,
  };
}

export function getWeatherMoratorium(args = {}) {
  return async function (dispatch) {
    dispatch(status.startProcessing());
    try {
      const res = await fetch(
        constants.LIST_WEATHER_MORATORIUM_URL,
        args
      );
      await dispatch(getWeatherMoratoriumSuccess(res));
    } catch (error) {
      dispatch(status.setErrorMessage(error.message));
    } finally {
      dispatch(status.finishProcessing());
    }
  };
}


export function getTDSPCounties(args = {}) {
  return async function (dispatch) {
    dispatch(status.startProcessing());
    try {
      const res = await fetch(
        constants.LIST_TDSP_COUNTIES_URL,
        args
      );
      await dispatch(getTDSPCountiesSuccess(res));
    } catch (error) {
      dispatch(status.setErrorMessage(error.message));
    } finally {
      dispatch(status.finishProcessing());
    }
  };
}

export function createWeatherMoratorium(data) {
  return async function (dispatch) {
    dispatch(status.startProcessing());
    try {
      const res = await fetch(
        constants.CREATE_WEATHER_MORATORIUM_URL,
        data
      );
      await dispatch(getWeatherMoratorium());
    } catch (error) {
      dispatch(status.setErrorMessage(error.message));
    } finally {
      dispatch(status.finishProcessing());
    }
  };
}

export function updateWeatherMoratorium(data) {
  return async function (dispatch) {
    dispatch(status.startProcessing());
    try {
      const res = await fetch(
        constants.UPDATE_WEATHER_MORATORIUM_URL,
        data
      );
      await dispatch(getWeatherMoratorium());
    } catch (error) {
      dispatch(status.setErrorMessage(error.message));
    } finally {
      dispatch(status.finishProcessing());
    }
  };
}